import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitokonkandarshancabbooking() {



const cardData = {
  keyword: "Mumbai to Konkan Darshan Cab Booking",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Konkan Darshan cab services for travelers who want to explore the scenic Konkan coast, including beaches, forts, waterfalls, and cultural attractions. Whether you are planning a family vacation, a weekend getaway, a honeymoon trip, or a group tour, our cab service ensures safe and convenient travel with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance and coastal routes, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Konkan Darshan cab services.",

topPlaces: [
  {
    title: "Ganpatipule Beach",
    description:
      "Ganpatipule Beach is a pristine sandy beach on the Konkan coast, known for its clear waters, tranquil environment, and scenic beauty. Visitors can enjoy sunbathing, swimming, photography, and leisurely walks along the shore. A cab ride ensures comfortable travel from Mumbai, allowing travelers to plan their visit at leisure, explore nearby eateries, and enjoy the beach without worrying about local transport or parking."
  },
  {
    title: "Ratnagiri Fort",
    description:
      "Ratnagiri Fort, also known as Ratnadurg Fort, is a historic coastal fort offering panoramic views of the Arabian Sea and the surrounding landscape. Visitors can explore the fortifications, enjoy photography, and learn about the region’s history. Traveling by cab allows visitors to reach the fort comfortably, combine it with other nearby sightseeing spots, and spend ample time enjoying the coastal views."
  },
  {
    title: "Tarkarli Beach",
    description:
      "Tarkarli Beach is famous for its white sands, clear waters, and water sports like snorkeling, scuba diving, and jet skiing. The beach also offers boat rides to nearby Sindhudurg Fort. Using a cab service ensures safe and convenient travel, allowing visitors to enjoy adventure activities, relax by the sea, and plan their day efficiently along the Konkan coast."
  },
  {
    title: "Sindhudurg Fort",
    description:
      "Sindhudurg Fort, located on a small island off the coast, is a historic fort built by Chhatrapati Shivaji Maharaj. Visitors can explore the fort’s architecture, learn about its history, and enjoy stunning sea views. Traveling by cab allows travelers to reach the fort’s base conveniently and take a boat ride to the island without transport hassles."
  },
  {
    title: "Velas Beach & Turtle Festival",
    description:
      "Velas Beach is known for its pristine sands, nesting Olive Ridley turtles, and eco-tourism activities. Visitors can witness turtle hatching during the nesting season, enjoy peaceful beach walks, and explore local nature trails. A cab ride ensures comfortable access, making it easier to plan visits during the festival season and explore nearby attractions along the Konkan coast."
  },
  {
    title: "Jaigad Fort",
    description:
      "Jaigad Fort is a coastal fort near Ratnagiri, offering spectacular views of the sea, cliffs, and surrounding landscapes. Visitors can explore the fort, take photographs, and enjoy the natural surroundings. Using a cab allows travelers to reach the fort comfortably and integrate the visit with other Konkan Darshan stops efficiently."
  },
  {
    title: "Bhatye Beach",
    description:
      "Bhatye Beach is a serene and less-crowded beach near Ratnagiri, ideal for peaceful walks, photography, and relaxing by the sea. Traveling by cab provides convenient access and the flexibility to spend time enjoying the natural beauty without worrying about local transport or parking."
  },
  {
    title: "Marleshwar Temple & Waterfall",
    description:
      "Marleshwar Temple is a hilltop Shiva temple near Chiplun, accompanied by a scenic waterfall. Visitors can enjoy spiritual visits, trekking, and nature photography. A cab ride ensures comfortable transport to the temple base, making it easy to plan both the temple visit and waterfall exploration in a single trip."
  },
  {
    title: "Anjarle Beach & Ganesh Temple",
    description:
      "Anjarle Beach is a quiet coastal spot with golden sands, along with a historic Ganesh temple nearby. Visitors can combine spiritual and leisure activities, enjoy beach walks, and explore local culture. Traveling by cab provides convenient access to both the temple and the beach, ensuring a seamless Konkan Darshan experience."
  },
  {
    title: "Kunkeshwar Temple",
    description:
      "Kunkeshwar Temple is a coastal Shiva temple near Devgad, set against the backdrop of the Arabian Sea. The temple attracts devotees and tourists for its serene atmosphere, spiritual significance, and scenic location. A cab service allows comfortable travel from Mumbai, letting visitors explore this spiritual site alongside other Konkan destinations without transport concerns."
  }
],




services: [
{
name: "Mumbai to Konkan Darshan Cab",
description: "Mumbai to Konkan Darshan cab service offers comfortable travel for tourists exploring the beautiful Konkan coastline. Our AC sedans, SUVs, and premium vehicles ensure smooth highway journeys through scenic coastal routes. Professional drivers are experienced with Konkan destinations like Ganpatipule, Ratnagiri, Tarkarli, and Sindhudurg. Pickup is available from homes, hotels, offices, and Mumbai airport. Ideal for family vacations, temple visits, and beach tourism."
},
{
name: "Mumbai to Konkan Taxi",
description: "Mumbai to Konkan taxi service provides reliable road transportation for travelers planning coastal tours in the Konkan region. Comfortable AC vehicles ensure relaxed long-distance travel. Experienced drivers guide passengers safely through scenic highways and coastal roads."
},
{
name: "Mumbai to Konkan Tour Cab",
description: "Mumbai to Konkan tour cab service is perfect for tourists planning multi-destination travel across the Konkan region. Spacious vehicles and experienced drivers ensure smooth journeys through beaches, temples, and coastal towns."
},
{
name: "Mumbai to Konkan Darshan Taxi",
description: "Mumbai to Konkan darshan taxi service offers convenient transportation for travelers visiting famous Konkan temples and tourist spots. Comfortable vehicles ensure relaxed travel across scenic routes."
},
{
name: "Konkan Tour Cab from Mumbai",
description: "Konkan tour cab from Mumbai provides a complete travel solution for exploring the beautiful Konkan coastline. AC vehicles and professional drivers ensure safe and comfortable long-distance travel."
},
{
name: "Mumbai to Konkan Cab Booking",
description: "Mumbai to Konkan cab booking allows travelers to reserve vehicles easily for coastal tours. Instant booking confirmation and flexible pickup options simplify travel planning."
},
{
name: "Mumbai to Konkan Tour Package Cab",
description: "Mumbai to Konkan tour package cab provides a complete travel experience covering major Konkan destinations. Comfortable vehicles and experienced drivers ensure smooth journeys across beaches and temples."
},
{
name: "Mumbai to Konkan Beach Tour Taxi",
description: "Mumbai to Konkan beach tour taxi service is ideal for tourists planning beach vacations along the Konkan coast. Comfortable AC vehicles ensure relaxed journeys to destinations like Ganpatipule and Tarkarli."
},
{
name: "Mumbai to Konkan Family Trip Cab",
description: "Mumbai to Konkan family trip cab service offers spacious vehicles perfect for family vacations along the Konkan coast. Experienced drivers ensure safe travel and enjoyable sightseeing journeys."
},
{
name: "Mumbai to Konkan Sightseeing Cab",
description: "Mumbai to Konkan sightseeing cab service provides comfortable travel for exploring beaches, temples, and historical places in the Konkan region. Reliable vehicles and professional drivers ensure smooth coastal travel."
}
],

tableData: [
["Mumbai to Konkan Darshan Cab","Mumbai to Konkan Taxi"],
["Mumbai to Konkan Tour Cab","Mumbai to Konkan Darshan Taxi"],
["Konkan Tour Cab from Mumbai","Mumbai to Konkan Cab Booking"],
["Mumbai to Konkan Tour Package Cab","Mumbai to Konkan Beach Tour Taxi"],
["Mumbai to Konkan Family Trip Cab","Mumbai to Konkan Sightseeing Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Konkan Route Drivers",
    WhyChoosedescription: "Our drivers have extensive experience driving along the beautiful Konkan coastal routes from Mumbai. They know the best highways, scenic coastal roads, and temple locations across Ratnagiri, Ganpatipule, Tarkarli, and Sindhudurg, ensuring a smooth and memorable Konkan Darshan journey."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs follows a clear and transparent pricing system for Konkan Darshan cab bookings. We provide detailed package pricing, travel distance, and route plans in advance so customers can book their trip with complete confidence and no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Konkan trips often start early in the morning or involve overnight travel. Omshree Cabs offers 24/7 booking and customer support so you can plan your Konkan Darshan journey anytime without worry."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our vehicles are well-maintained, fully air-conditioned, and sanitized regularly. Long coastal journeys become more comfortable when you travel in our clean and spacious vehicles designed for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Konkan Tour Packages",
    WhyChoosedescription: "We provide flexible Konkan Darshan packages including 2-day, 3-day, and multi-day coastal tours. Travelers can customize their itinerary to include popular destinations like Ganpatipule, Ratnagiri, Sindhudurg Fort, Tarkarli Beach, and other Konkan attractions."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and larger vehicles for group travel. Choose the ideal vehicle for your family trip or group Konkan tour."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from your home, hotel, office, or airport anywhere in Mumbai. Our drivers arrive on time so your Konkan Darshan journey begins smoothly and comfortably."
  },
  {
    WhyChooseheading: "Reliable Coastal Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Konkan coastal tours. With safe driving, punctual service, and professional drivers, we ensure your Konkan Darshan trip is relaxing, scenic, and hassle-free."
  }
]
};

const faqData = [
  { question: "What is Konkan Darshan from Mumbai?", answer: "Konkan Darshan is a coastal tour covering popular destinations like Ganpatipule, Ratnagiri, Tarkarli, Sindhudurg Fort, and other scenic beaches and temples in the Konkan region." },
  { question: "How many days are required for Konkan Darshan?", answer: "Most travelers complete Konkan Darshan in 2–4 days depending on the number of destinations included in the itinerary." },
  { question: "Do you provide complete Konkan Darshan cab packages?", answer: "Yes, Omshree Cabs offers complete Konkan Darshan cab packages starting from Mumbai with customizable itineraries." },
  { question: "Which vehicles are available for Konkan travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and larger vehicles for family or group travel." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Konkan tour bookings." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we customize the Konkan travel itinerary?", answer: "Yes, travelers can customize the route, destinations, and travel schedule according to their preferences." },
  { question: "Do drivers know the Konkan tourist locations?", answer: "Yes, our drivers are familiar with all major Konkan tourist destinations and coastal routes." },
  { question: "Is advance booking recommended for Konkan tours?", answer: "Yes, advance booking is recommended especially during holidays and tourist seasons." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Patil",
    feedback:
      "We booked Omshree Cabs for a Konkan Darshan tour from Mumbai. The driver knew all the coastal routes and tourist spots. The journey was smooth and very enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rupal Shah",
    feedback:
      "Our Konkan family trip with Omshree Cabs was fantastic. Clean vehicle, professional driver, and excellent planning made the trip very comfortable.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab Booking",
  "description": "Book Mumbai to Konkan Darshan Cab with Omshree Cab for comfortable Konkan tour and sightseeing. Reliable taxi service for Konkan beach tours, family trips, and temple visits from Mumbai. Affordable cab packages with easy online booking for your Konkan Darshan tour.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1650"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Mumbai to Konkan Darshan Cab Booking | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Konkan Darshan Cab with Omshree Cab for Konkan beach tours and sightseeing. Taxi service for Konkan family trips with affordable cab packages and easy online booking from Mumbai." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokonkandarshancabbooking;